<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (station) {
    <div class="entity-config-panel">
        <div class="header">
            <button (click)="closePanel()" windeClose>
                <sui-svg-icon icon="cross"/>
            </button>
        </div>
        <form [formGroup]="editForm" name="editUnitConfigForm">
            <div class="form-group-sm">
                <span class="form-label mt-2">Location name:</span>
                @if (historyService.isEditModeEnabled && !hasFreezeLink) {
                    <input
                            [ngClass]="{ 'ng-invalid': name === '' }"
                            class="form-control"
                            formControlName="name"
                            id="name"
                            maxlength="70"
                            type="text"
                    />
                } @else {
                    <span class="d-block">{{ name }}</span>
                }
            </div>
            <div class="form-group-sm">
                <span class="form-label">Location Longitude (-180 to 180):</span>
                @if (historyService.isEditModeEnabled && !hasFreezeLink) {
                    <div>
                        <input
                                class="form-control form-control-sm"
                                formControlName="lng"
                                id="lng"
                                max="180"
                                min="-180"
                                step="0.000001"
                                type="number"
                        />
                        <small class="form-text text-muted">(-180 to 180)</small>
                    </div>
                } @else {
                    {{ station.getPosition().longitude }}
                }
            </div>
            <div class="form-group-sm">
                <span class="form-label">Location Latitude (-90 to 90):</span>
                @if (historyService.isEditModeEnabled && !hasFreezeLink) {
                    <div>
                        <input
                                class="form-control form-control-sm"
                                formControlName="lat"
                                id="lat"
                                max="90"
                                min="-90"
                                step="0.000001"
                                type="number"
                        />
                        <small class="form-text text-muted">(-90 to 90)</small>
                    </div>
                } @else {
                    {{ station.getPosition().latitude }}
                }
            </div>
            @if (historyService.isEditModeEnabled && !hasFreezeLink) {
                <div class="form-group-sm">
                    <span class="form-label">Height ({{ historyService.logicalTopology.productUnits }}):</span>
                    <div class="row">
                        <div class="col-5">
                            <input class="form-control form-control-sm" formControlName="height" id="height" min="0" type="number"/>
                        </div>
                        <div class="col-7 form-group mb-0" style="margin-top: -4px">
                            <div class="form-check form-check-inline">
                                <input
                                        [value]="altitudeModeEnumValues.RELATIVE"
                                        class="form-check-input mt-0"
                                        formControlName="alt_mode"
                                        id="alt_mode_RELATIVE"
                                        type="radio"
                                />
                                <span class="form-check-label">Relative to ground</span>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                        [value]="altitudeModeEnumValues.ABSOLUTE"
                                        class="form-check-input mt-0"
                                        formControlName="alt_mode"
                                        id="alt_mode_ABSOLUTE"
                                        type="radio"
                                />
                                <span class="form-check-label">Absolute</span>
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="form-group-sm">
                    <span class="form-label node-height-read-only">
                        Height
                        {{ station.getHeight() }}{{ historyService.logicalTopology.productUnits }},
                        {{ station.getAltitudeMode() === 1 ? 'Relative to ground' : 'Absolute' }}
                    </span>
                </div>
            }
        </form>
    </div>
}
